<template>
  <div>
    <section class="newsList ">

    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    }
  },
  methods: {
    goView(id,t) {
      console.log(t)
    }
  },
  mounted(){

  }
}
</script>

<style scoped lang="less">
.newsList {
  padding: 0 10px;

  .labletitle {
    // font-family: caoshu1;
    font-size: 18px;
    color: #323953;

  }
}

</style>